export function isCreatureGalleryDebugMode(search = globalThis.location?.search ?? ''): boolean {
  const normalized = search.startsWith('?') ? search : `?${search}`;
  return new URLSearchParams(normalized).get('debug') === 'creatures';
}
